import type { PendingAuthConsent } from "./pendingAuthConsent";

type CompletePendingAuthSetupParams = {
  pendingConsent: PendingAuthConsent | null;
  recordAuthConsents: (params: {
    consents: PendingAuthConsent["consents"];
    source: string;
  }) => Promise<unknown>;
  updateMarketingPreferences: (params: {
    marketingConsent: boolean;
    nightMarketingConsent: boolean;
    marketingConsentMethod: string;
  }) => Promise<unknown>;
  recordRequiredConsents?: boolean;
};

export async function completePendingAuthSetup({
  pendingConsent,
  recordAuthConsents,
  updateMarketingPreferences,
  recordRequiredConsents = true,
}: CompletePendingAuthSetupParams) {
  if (!pendingConsent) {
    return;
  }

  if (recordRequiredConsents) {
    await recordAuthConsents({
      consents: pendingConsent.consents,
      source: pendingConsent.source,
    });
  }

  if (pendingConsent.marketingConsent) {
    await updateMarketingPreferences({
      marketingConsent: true,
      nightMarketingConsent: false,
      marketingConsentMethod: pendingConsent.source,
    });
  }
}
